import React from 'react';
import ASSETS from '../../../assets';

const Journey = () => {
  return (
    <>
      <div className='flex lg:flex-row flex-col-reverse items-center justify-between gap-10'>
        <div className='max-w-[512px]'>
          <img src={ASSETS[1]} alt='' />
        </div>
        <div className='lg:min-w-[400px]'>
          <div className='bg-l-light-grey px-3 py-[6px] rounded inline-block'>
            <p className='text-sm font-semibold text-l-primary uppercase'>
              FIND YOUR LAWYER
            </p>
          </div>
          <p className='lg:text-[36px] lg:leading-[54px] text-3xl leading-[44px] text-l-primary font-bold max-w-[27ch] mt-6'>
            Find a perfect lawyer for your unique situation
          </p>
          <p className='text-l-body md:text-lg text-base max-w-[55ch] mt-[32px]'>
            Whether you’re facing a business dispute or navigating with family
            matters, you can find a perfect lawyer for any situation. ‘Find Your
            Lawyer’ helps you connect with specialized lawyers, ensuring you get
            tailored legal help. Now you can find lawyers based on specific
            requirements, including practice area, location, experience, and
            ratings.
          </p>
        </div>
      </div>
      <div className='flex lg:flex-row flex-col items-center justify-between gap-10 lg:mt-[180px] md:mt-[100px] mt-12'>
        <div className='lg:min-w-[400px]'>
          <div className='bg-l-light-grey px-3 py-[6px] rounded inline-block'>
            <p className='text-sm font-semibold text-l-primary uppercase'>
              BOOK APPOINTMENT
            </p>
          </div>
          <p className='lg:text-[36px] lg:leading-[54px] text-3xl leading-[44px]  text-l-primary font-bold max-w-[27ch] mt-6'>
            Connect with Top-rated Lawyers in Minutes
          </p>
          <p className='text-l-body md:text-lg text-base max-w-[55ch] mt-[32px]'>
            Ditch the traffic jams, and hours of wait in airless courtrooms. Our
            online appointment booking feature allows you to connect with
            lawyers in a few simple steps. Simply choose a lawyer from our legal
            network, find a suitable time slot, and your appointment is booked.
            Join Legal Avenue and get personalized legal advice from the comfort
            of your home.
          </p>
        </div>
        <div className='max-w-[512px]'>
          <img src={ASSETS[2]} alt='' />
        </div>
      </div>
      <div className='flex lg:flex-row flex-col-reverse items-center justify-between gap-10 lg:mt-[180px] md:mt-[100px] mt-12'>
        <div className='max-w-[512px]'>
          <img src={ASSETS[3]} alt='' />
        </div>
        <div className='lg:min-w-[400px]'>
          <div className='bg-l-light-grey px-3 py-[6px] rounded inline-block'>
            <p className='text-sm font-semibold text-l-primary uppercase'>
              Online Consultation
            </p>
          </div>
          <p className='lg:text-[36px] lg:leading-[54px] text-3xl leading-[44px]  text-l-primary font-bold max-w-[27ch] mt-6'>
            Get quick answers to your legal concerns via phone or chat
          </p>
          <p className='text-l-body md:text-lg text-base max-w-[55ch] mt-[32px]'>
            Skip the wait and get instant access to tailored legal advice
            through our ‘Call & Chat Consultation.’ Whether you prefer a quick
            phone call or a comprehensive chat, our legal attorneys can guide
            you in every way.
          </p>
        </div>
      </div>
      <div className='flex lg:flex-row flex-col items-center justify-between gap-10 lg:mt-[180px] md:mt-[100px] mt-12'>
        <div className='lg:min-w-[400px]'>
          <div className='bg-l-light-grey px-3 py-[6px] rounded inline-block'>
            <p className='text-sm font-semibold text-l-primary uppercase'>
              Join as a Lawyer
            </p>
          </div>
          <p className='lg:text-[36px] lg:leading-[54px] text-3xl leading-[44px]  text-l-primary font-bold max-w-[27ch] mt-6'>
            Make a Difference, Join us as a Lawyer
          </p>
          <p className='text-l-body md:text-lg text-base max-w-[55ch] mt-[32px]'>
            Are you a specialized lawyer? Do you want to make an impact in the
            legal world? Join our network of legal experts and make a difference
            by doing what you do best. By joining Legal Avenue, you can get
            access to a range of verified clients who’re looking for expert
            attorneys like yourself.
          </p>
        </div>
        <div className='max-w-[512px]'>
          <img src={ASSETS[4]} alt='' />
        </div>
      </div>
    </>
  );
};

export default Journey;
